/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/TermsAndConditions.ts":
/*!***********************************!*\
  !*** ./src/TermsAndConditions.ts ***!
  \***********************************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var TermsAndConditions = /*#__PURE__*/function (_HTMLElement) {
  function TermsAndConditions() {
    var _this;
    _classCallCheck(this, TermsAndConditions);
    _this = _callSuper(this, TermsAndConditions);
    _this.termsCheckmark = _this.querySelector(".terms_checkmark");
    _this.termsCheckbox = _this.querySelector("#terms_checkbox");
    _this.checkoutBtn = _this.querySelector("button[name='checkout']") || _this.querySelector("a[href='/checkout']");
    _this.popoverTerms = document.querySelector("#popover_terms");
    _this.popoverTermsContainer = document.querySelector(".popover_terms_container");
    _this.popoverTermsClose = document.querySelector("#popover_terms_close");
    _this.acceptTermsButton = document.querySelector("#accept_terms_button");
    _this.documentClickHandler = _this.documentClickHandler.bind(_this);
    _this.checkoutBtnHandler = _this.checkoutBtnHandler.bind(_this);
    _this.acceptTermsCloseHandler = _this.acceptTermsCloseHandler.bind(_this);
    _this.acceptTermsButtonHandler = _this.acceptTermsButtonHandler.bind(_this);
    _this.termsCheckboxChangeHandler = _this.termsCheckboxChangeHandler.bind(_this);
    return _this;
  }
  _inherits(TermsAndConditions, _HTMLElement);
  return _createClass(TermsAndConditions, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.checkoutBtn && this.termsCheckbox) {
        this.checkoutBtn.addEventListener("click", this.checkoutBtnHandler);
        this.popoverTermsClose.addEventListener("click", this.acceptTermsCloseHandler);
        this.termsCheckbox.addEventListener("change", this.termsCheckboxChangeHandler);
        this.acceptTermsButton.addEventListener("click", this.acceptTermsButtonHandler);
      }
    }
  }, {
    key: "checkoutBtnHandler",
    value: function checkoutBtnHandler(e) {
      if (!this.termsCheckbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.popoverTerms.classList.remove("tw-hidden");
      }
    }
  }, {
    key: "termsCheckboxChangeHandler",
    value: function termsCheckboxChangeHandler() {
      if (this.termsCheckbox.checked) {
        this.checkoutBtn.setAttribute("name", "checkout");
      } else {
        this.checkoutBtn.removeAttribute("name");
      }
    }
  }, {
    key: "acceptTermsButtonHandler",
    value: function acceptTermsButtonHandler() {
      var _this2 = this;
      this.termsCheckbox.click();
      this.termsCheckboxChangeHandler();
      setTimeout(function () {
        if (_this2.termsCheckbox.checked) {
          _this2.checkoutBtn.click();
        }
      }, 200);
    }
  }, {
    key: "documentClickHandler",
    value: function documentClickHandler(e) {
      var target = e.target;
      if (this.popoverTerms && !this.popoverTermsContainer.contains(target) && !this.checkoutBtn.contains(target)) {
        this.popoverTerms.classList.add("tw-hidden");
      }
    }
  }, {
    key: "acceptTermsCloseHandler",
    value: function acceptTermsCloseHandler(e) {
      e.preventDefault();
      this.popoverTerms.classList.add("tw-hidden");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("terms-conditions", TermsAndConditions);

/***/ }),

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _this = this;
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var defaultConsentSettings = {
  functionality_storage: 'granted',
  analytics_storage: 'denied',
  personalization_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  wait_for_update: 500
};
function updateConsentSettings(visitorConsent) {
  var consentUpdate = {
    functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'denied',
    analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
    personalization_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
    ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
    ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
    ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied'
  };
  // Merge default settings with visitor consent settings. If the visitor has not consented to a particular category, the default setting will be used.
  var mergedSettings = Object.assign(Object.assign({}, defaultConsentSettings), consentUpdate);
  gtag('consent', 'update', mergedSettings);
}
// Event listener for visitor consent collection
document.addEventListener('visitorConsentCollected', function (event) {
  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var visitorConsent;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!window.Shopify || !window.Shopify.customerPrivacy)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.next = 4;
          return window.Shopify.customerPrivacy.currentVisitorConsent();
        case 4:
          visitorConsent = _context.sent;
          updateConsentSettings(visitorConsent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
});
// Fetch and update consent settings on page load
function getVisitorConsent() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var visitorConsent;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!window.Shopify || !window.Shopify.customerPrivacy)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          _context2.next = 4;
          return window.Shopify.customerPrivacy.currentVisitorConsent();
        case 4:
          visitorConsent = _context2.sent;
          updateConsentSettings(visitorConsent);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
document.addEventListener('DOMContentLoaded', getVisitorConsent);
// Function to open the login modal
var openLoginModal = function openLoginModal() {
  var loginModal = document.getElementById('login-modal');
  if (loginModal) {
    loginModal.classList.remove('!tw-hidden');
  }
};
var closeLoginModal = function closeLoginModal() {
  var loginModal = document.getElementById('login-modal');
  if (loginModal) {
    loginModal.classList.add('!tw-hidden');
  }
};
var wishlistLoginButton = document.querySelectorAll('.wishlist_login_button');
if (wishlistLoginButton) {
  wishlistLoginButton.forEach(function (button) {
    button.addEventListener('click', openLoginModal);
  });
}
var loginModal = document.getElementById('login-modal');
if (loginModal) {
  loginModal.addEventListener('click', function (event) {
    var modalContent = document.getElementById('login-modal-content');
    if (modalContent && !modalContent.contains(event.target)) {
      closeLoginModal();
    }
  });
}
var closeButton = document.querySelectorAll('.close-modal-button');
if (closeButton) {
  closeButton.forEach(function (button) {
    button.addEventListener('click', closeLoginModal);
  });
}
function handleComponentUpdate() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var response, data, parser, parsedDocument, freshComponents, currentComponents;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetch("".concat(window.location.href, "?section_id=main-product"));
        case 3:
          response = _context3.sent;
          if (response.ok) {
            _context3.next = 6;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 6:
          _context3.next = 8;
          return response.text();
        case 8:
          data = _context3.sent;
          parser = new DOMParser();
          parsedDocument = parser.parseFromString(data, 'text/html');
          freshComponents = parsedDocument.querySelectorAll('wishlist-button');
          currentComponents = document.querySelectorAll('wishlist-button');
          currentComponents.forEach(function (currentComponent, index) {
            var freshComponent = freshComponents[index];
            if (freshComponent) {
              if (currentComponent.outerHTML !== freshComponent.outerHTML) {
                currentComponent.replaceWith(freshComponent);
              }
            }
          });
          _context3.next = 19;
          break;
        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](0);
          console.error('Error fetching product page:', _context3.t0);
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 16]]);
  }));
}
document.addEventListener('cc-variant-changed', function (event) {
  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return handleComponentUpdate();
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
});
var Anyday = /*#__PURE__*/function (_HTMLElement) {
  function Anyday() {
    var _this2;
    _classCallCheck(this, Anyday);
    _this2 = _callSuper(this, Anyday);
    _this2.openModal = _this2.openModal.bind(_this2);
    _this2.closeModal = _this2.closeModal.bind(_this2);
    _this2.getContentFromSection = _this2.getContentFromSection.bind(_this2);
    _this2.handleSelection = _this2.handleSelection.bind(_this2);
    return _this2;
  }
  _inherits(Anyday, _HTMLElement);
  return _createClass(Anyday, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.openModal);
    }
  }, {
    key: "reInitEvents",
    value: function reInitEvents() {
      var _this3 = this;
      var closeBtn = document.querySelector('.anyday-dialog-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.closeModal);
      }
      var options = document.querySelectorAll('.anyday-payment-option');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          _this3.handleSelection(options, option);
        });
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.getContentFromSection();
      var anydayOverlay = document.querySelector('.anyday-overlay-mask');
      var anydayModal = document.querySelector('.anyday-dialog-box');
      if (anydayOverlay) {
        anydayOverlay.style.zIndex = '9999';
        anydayOverlay.classList.add('anyday-overlay-active');
      }
      if (anydayModal) {
        anydayModal.classList.add('anyday-show');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "closeModal",
    value: function closeModal() {
      var anydayOverlay = document.querySelector('.anyday-overlay-mask');
      var anydayModal = document.querySelector('.anyday-dialog-box');
      if (anydayOverlay) {
        anydayOverlay.style.zIndex = '-1';
        anydayOverlay.classList.remove('anyday-overlay-active');
      }
      if (anydayModal) {
        anydayModal.classList.remove('anyday-show');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleSelection",
    value: function handleSelection(options, option) {
      options.forEach(function (opt) {
        opt.classList.remove('anyday-payment-option-selected');
      });
      option.classList.add('anyday-payment-option-selected');
    }
  }, {
    key: "getContentFromSection",
    value: function getContentFromSection() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var url, response, responseText, fresh, selectorElement, freshContent;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // eslint-disable-next-line prefer-destructuring
              url = this.dataset.url;
              _context5.prev = 1;
              _context5.next = 4;
              return window.fetch("".concat(url, "?section_id=anyday"));
            case 4:
              response = _context5.sent;
              if (!response.ok) {
                _context5.next = 17;
                break;
              }
              _context5.next = 8;
              return response.text();
            case 8:
              responseText = _context5.sent;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              selectorElement = document.querySelector('[data-anyday-content]');
              freshContent = fresh.querySelector('[data-anyday-content]');
              if (!(selectorElement && freshContent)) {
                _context5.next = 17;
                break;
              }
              if (!(selectorElement.innerHTML === freshContent.innerHTML)) {
                _context5.next = 16;
                break;
              }
              return _context5.abrupt("return");
            case 16:
              selectorElement.innerHTML = freshContent.innerHTML;
            case 17:
              _context5.next = 22;
              break;
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](1);
              _context5.t0.log(_context5.t0);
            case 22:
              _context5.prev = 22;
              this.reInitEvents();
              return _context5.finish(22);
            case 25:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 19, 22, 25]]);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('edition-anyday', Anyday);

/***/ }),

/***/ "./src/reload-cart.ts":
/*!****************************!*\
  !*** ./src/reload-cart.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionReloadCart)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var EditionReloadCart = /*#__PURE__*/function () {
  function EditionReloadCart() {
    _classCallCheck(this, EditionReloadCart);
    // Binding the context of "this" to the methods
    this.reloadCart = this.reloadCart.bind(this);
    this.init = this.init.bind(this);
  }
  return _createClass(EditionReloadCart, [{
    key: "init",
    value: function init() {
      // Attaching an event listener for the custom 'Edition:cart:reload' event
      document.addEventListener('Edition:cart:reload', this.reloadCart);
    }
    // Method to reload the cart content
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "reloadCart",
    value: function reloadCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, responseText, fresh, cart;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return window.fetch("".concat(window.Shopify.routes.root_url, "?section_id=cart-drawer"));
            case 3:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 14;
                break;
              }
              _context.next = 7;
              return response.text();
            case 7:
              responseText = _context.sent;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              cart = document.getElementById('cart-drawer');
              if (cart) {
                cart.innerHTML = fresh.innerHTML;
              } else {
                console.warn('Cart element not found');
              }
              _context.next = 15;
              break;
            case 14:
              throw new Error('Failed to fetch cart');
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              console.error('Error fetching cart:', _context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 17]]);
      }));
    }
  }]);
}();


/***/ }),

/***/ "./src/wishlist.ts":
/*!*************************!*\
  !*** ./src/wishlist.ts ***!
  \*************************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
function fetchProductAndUpdateButton() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var productUrl, response, data, variants, selectedVariant, wishlistButton, localWishlistItems, wishlistItems, exists;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          productUrl = window.productUrl;
          _context.prev = 1;
          _context.next = 4;
          return fetch("".concat(productUrl, ".json"));
        case 4:
          response = _context.sent;
          _context.next = 7;
          return response.json();
        case 7:
          data = _context.sent;
          if (!response.ok) {
            _context.next = 14;
            break;
          }
          variants = data.product.variants;
          selectedVariant = variants.find(function (variant) {
            return window.location.href.includes("variant=".concat(variant.id));
          });
          if (selectedVariant) {
            wishlistButton = document.querySelector("wishlist-button");
            wishlistButton.dataset.title = "".concat(data.product.title, " ").concat(selectedVariant.title);
            wishlistButton.dataset.id = selectedVariant.id;
            wishlistButton.dataset.price = selectedVariant.price.toString();
            wishlistButton.dataset.url = productUrl;
            wishlistButton.dataset.handle = data.product.handle;
            wishlistButton.dataset.images = selectedVariant.featured_image.src;
            wishlistButton.dataset.cart =  true ? "true" : 0;
            localWishlistItems = localStorage.getItem("wishlist_items");
            wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
            exists = wishlistItems.some(function (item) {
              return item.id == selectedVariant.id;
            });
            if (exists) {
              wishlistButton.classList.add("is-animating");
            } else {
              wishlistButton.classList.remove("is-animating");
            }
          }
          _context.next = 16;
          break;
        case 14:
          console.log(response);
          throw new Error("Network response was not ok");
        case 16:
          _context.next = 21;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
          console.log(_context.t0);
        case 21:
          _context.prev = 21;
          document.dispatchEvent(new Event("wishlist-changed"));
          return _context.finish(21);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 18, 21, 24]]);
  }));
}
function removeItemFromCart(variantId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (variantId) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          _context2.prev = 2;
          _context2.next = 5;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates: _defineProperty({}, variantId, 0)
            })
          });
        case 5:
          response = _context2.sent;
          if (!response.ok) {
            _context2.next = 10;
            break;
          }
          _context2.next = 9;
          return response.json();
        case 9:
          data = _context2.sent;
        case 10:
          if (response.ok) {
            _context2.next = 13;
            break;
          }
          console.log(response);
          throw new Error("Network response was not ok");
        case 13:
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](2);
          console.log(_context2.t0);
        case 18:
          _context2.prev = 18;
          document.dispatchEvent(new Event("wishlist-changed"));
          return _context2.finish(18);
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 15, 18, 21]]);
  }));
}
function AddToCart(FormData) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(FormData)
          });
        case 3:
          response = _context3.sent;
          if (!response.ok) {
            _context3.next = 8;
            break;
          }
          _context3.next = 7;
          return response.json();
        case 7:
          data = _context3.sent;
        case 8:
          if (response.ok) {
            _context3.next = 11;
            break;
          }
          console.log(response);
          throw new Error("Network response was not ok");
        case 11:
          _context3.next = 16;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          console.log(_context3.t0);
        case 16:
          _context3.prev = 16;
          document.dispatchEvent(new CustomEvent("theme:cartchanged", {
            bubbles: true,
            cancelable: false
          }));
          document.dispatchEvent(new CustomEvent("theme:open-cart-drawer", {
            bubbles: true,
            cancelable: false
          }));
          document.dispatchEvent(new Event("wishlist-changed"));
          return _context3.finish(16);
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13, 16, 21]]);
  }));
}
function renderWishList(wishlistItems) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var itemHTML, _iterator, _step, _loop;
    return _regeneratorRuntime().wrap(function _callee4$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          itemHTML = "";
          _iterator = _createForOfIteratorHelper(wishlistItems);
          _context5.prev = 2;
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var item, handle, productUrl, productResponse, productData, variants, currentVariantId, currentVariant, currentVariantTitle, productJson, preorderInfo, preorderInfoArray, currentVariantIsPreoder, currentVariantIsAvailable, variantListItems, customDropdownHTML, status, removeTextData, addToCartTextData, soldOutTextData, availability, opacity, color, waitlistLabel, comparePriceHtml, saleLabelText, showPreOrderLabel, productLabel;
            return _regeneratorRuntime().wrap(function _loop$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  item = _step.value;
                  handle = item.handle;
                  productUrl = "/products/".concat(handle);
                  _context4.next = 5;
                  return fetch("".concat(productUrl, ".js"));
                case 5:
                  productResponse = _context4.sent;
                  _context4.next = 8;
                  return productResponse.json();
                case 8:
                  productData = _context4.sent;
                  variants = productData.variants;
                  currentVariantId = Number(item.id);
                  currentVariant = variants.find(function (v) {
                    return v.id === currentVariantId;
                  });
                  currentVariantTitle = currentVariant ? currentVariant.title : "";
                  productJson = item.productjson;
                  console.log("item", item);
                  // preorder is a string like this "[{'54963773964661': 'true'},{'54963773997429': 'true'},{'54963774030197': 'true'},{'54963774062965': 'true'}]"
                  // I want it as an array of objects like this [{id: 54963773964661, available: true}, {id: 54963773997429, available: true}, ...]
                  preorderInfo = item.preorderinfo;
                  if (preorderInfo !== "[]" && preorderInfo !== "" && preorderInfo !== null && preorderInfo !== undefined) {
                    preorderInfoArray = preorderInfo.replace(/[\[\]{}']/g, "").split(",").map(function (item) {
                      var _item$split = item.split(":"),
                        _item$split2 = _slicedToArray(_item$split, 2),
                        id = _item$split2[0],
                        preorder = _item$split2[1];
                      var preOrderValue = preorder.trim() === "true";
                      //  return the id and boolean value of preorder
                      return {
                        id: Number(id),
                        preorder: preOrderValue
                      };
                    });
                  }
                  // check if the currentVariant is preorder
                  currentVariantIsPreoder = preorderInfoArray ? preorderInfoArray.find(function (item) {
                    return item.id === currentVariantId && item.preorder;
                  }) : false;
                  currentVariantIsAvailable = currentVariant ? currentVariant.available : false;
                  console.log("variants", variants);
                  variantListItems = "";
                  variants.forEach(function (variant) {
                    var variantIdNum = Number(variant.id);
                    var isPreOrder = preorderInfoArray ? preorderInfoArray.find(function (item) {
                      return item.id === variantIdNum && item.preorder;
                    }) : false;
                    var isAvailable = variant.available;
                    console.log("variant is available", isAvailable);
                    variantListItems += "\n        <li\n          class=\"variant-item ".concat(variantIdNum === currentVariantId ? "selected" : "", "\"\n          data-variant-id=\"").concat(variantIdNum, "\"\n          data-available=\"").concat(isAvailable, "\"\n        >\n          <span style=\"font-weight:500; ").concat(!isAvailable ? "color:darkgray;" : "", "\">\n            ").concat(variant.title, "\n          </span>\n          ").concat(isPreOrder ? "<span style=\"text-align:right;\">Forudbestil</span>" : "", "\n          ").concat(!isAvailable ? "<span style=\"text-decoration:underline;text-align:right;\">Tilmeld venteliste</span>" : "", " \n        </li>\n         ").concat(!isAvailable ? "<a href=\"#\" class=\"BIS_trigger tw-hidden\" data-product-data='".concat(productJson, "' data-variant-id=\"").concat(variant.id, "\">123</a>") : "", "\n      ");
                  });
                  // Create the custom dropdown with the known variant title
                  customDropdownHTML = "\n      <div class=\"custom-dropdown wishlist_variant_picker\">\n        <div class=\"selected-variant\">\n            <span style=\"font-weight:500;\">".concat(currentVariantTitle, "</span>\n            ").concat(currentVariantIsPreoder ? "<span style=\"text-align:right;\">Forudbestil</span>" : "", "\n            ").concat(!currentVariantIsAvailable ? "<span style=\"text-decoration:underline;text-align:right;\">Tilmeld venteliste</span>" : "", "          \n        </div>\n        <ul class=\"variant-list\" style=\"display: none;\">\n          ").concat(variantListItems, "\n        </ul>\n      </div>\n    ");
                  _context4.next = 25;
                  return getProductData(productUrl, currentVariantId);
                case 25:
                  status = _context4.sent;
                  removeTextData = document.querySelector(".wishlist_element_wrapper").getAttribute("data-remove-text");
                  addToCartTextData = document.querySelector(".wishlist_element_wrapper").getAttribute("data-add-to-cart-text");
                  soldOutTextData = document.querySelector(".wishlist_element_wrapper").getAttribute("data-sold-out-text"); // If status is false => product is sold out
                  availability = status ? "" : "disabled";
                  opacity = status ? "" : "tw-opacity-50";
                  color = status ? "tw-bg-[#196450]" : "tw-bg-[#6b6b6b]";
                  waitlistLabel = !status ? "<span class=\"wishlist_waite_badge product-label product-label--sale\">\n          <img height=\"55\" width=\"55\" loading=\"lazy\" src=\"//fashionbystrand.com/cdn/shop/t/117/assets/tilmeld-venteliste.png?v=7240073107463983851741353376\" alt=\"Tilmeld venteliste\">  \n        </span>" : "";
                  comparePriceHtml = item.compare_at_price ? "<span class=\"product-price__item product-price__compare theme-money\">".concat(item.compare_at_price, "</span>") : "";
                  saleLabelText = item.salelabeltext ? "<span class=\"wishlist_sale_badge product-label product-label--sale ".concat(item.productlabel ? "!tw-top-[40px]" : "", "\"><span>").concat(item.salelabeltext, "</span></span>") : "";
                  showPreOrderLabel = item.preorderbadge === "true" ? "<span class=\"product-price__item price-label price-label--preorder !tw-left-[10px] !tw-top-[10px]\">".concat(item.preordertext, "</span>") : "";
                  productLabel = item.productlabel ? "<span class=\"wishlist_product_label product-label product-label--meta\">\n          <span>".concat(item.productlabel, "</span>\n          </span>") : "";
                  itemHTML += "\n      <div data-id=\"".concat(item.id, "\" data-handle=\"").concat(item.handle, "\" class=\"wishlist-item\">\n        <div class=\"wishlist-item-info wishlist_item_info\">\n          <div class=\"wishlist_item_image_wrapper\">\n            <a class=\"wishlist_image_wrapper\" href=\"").concat(item.url, "\">\n              ").concat(waitlistLabel, "\n              ").concat(productLabel, "\n              ").concat(showPreOrderLabel, "\n              ").concat(saleLabelText, "\n              <img \n                class=\"wishlist_item_image  ").concat(opacity, "\" \n                style=\"--wh-ratio: 1.0;width:100%;\" \n                src=\"").concat(item.images, "\" \n                alt=\"").concat(item.title, "\" \n              />\n            </a>\n            <div class=\"wishlist_button_wrapper ").concat(opacity, "\">\n              ").concat(customDropdownHTML, "              \n              <wishlist-add_to_cart class=\"wishlist_item_buy_button\" data-id=\"").concat(item.id, "\">\n                <button class=\"wishlist_add_to_cart_button ").concat(color, "\" ").concat(availability, ">\n                  <svg \n                    class=\"js-go-cart-add-to-cart svgcart\" \n                    width=\"20px\" \n                    height=\"20px\" \n                    viewBox=\"0 0 24 24\" \n                    aria-hidden=\"true\"\n                  >\n                    <g \n                      class=\"js-go-cart-add-to-cart\" \n                      stroke=\"none\" \n                      stroke-width=\"1\" \n                      fill=\"none\" \n                      fill-rule=\"evenodd\"\n                    >\n                      <path \n                        class=\"js-go-cart-add-to-cart\" \n                        d=\"M3.5,2.75 C4.87766445,2.75 5.56649668,2.75 5.56649668,2.75 C5.56649668,2.75 6.03257795,7.25 6.96474049,16.25 L19.5,16.25\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.5\" \n                        stroke-linecap=\"square\"\n                      ></path>\n                      <path \n                        class=\"js-go-cart-add-to-cart\" \n                        d=\"M6.22627526,6.67553191 C14.8659742,6.67553191 19.1858237,6.67553191 19.1858237,6.67553191 C19.1858237,6.67553191 18.9160351,8.71453901 18.376458,12.7925532 L7.62925996,13.9095745\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.5\" \n                        stroke-linecap=\"square\"\n                      ></path>\n                      <circle \n                        class=\"js-go-cart-add-to-cart\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.25\" \n                        cx=\"8.875\" \n                        cy=\"20.005\" \n                        r=\"1.375\"\n                      ></circle>\n                      <circle \n                        class=\"js-go-cart-add-to-cart\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.25\" \n                        cx=\"17.375\" \n                        cy=\"20.005\" \n                        r=\"1.375\"\n                      ></circle>\n                    </g>\n                  </svg>\n                </button>\n              </wishlist-add_to_cart>\n            </div>\n          </div>\n          <a href=\"").concat(item.url, "\" class=\"").concat(opacity, "\">\n            <div class=\"product-block__title wishlist_item_title\">").concat(item.title, "</div>\n            <p class=\"product-price__item tw-m-0 wishlist_item_price product-price__amount theme-money\">\n              <span>").concat(item.price, "</span><span class=\"product-price__compare theme-money\">").concat(comparePriceHtml, "</span>\n            </p>\n          </a>\n          <remove-item class=\"wishlist_remove_item remove-item\">\n            ").concat(removeTextData, "\n          </remove-item>\n        </div>\n      </div>\n    ");
                case 38:
                case "end":
                  return _context4.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 5:
          if ((_step = _iterator.n()).done) {
            _context5.next = 9;
            break;
          }
          return _context5.delegateYield(_loop(), "t0", 7);
        case 7:
          _context5.next = 5;
          break;
        case 9:
          _context5.next = 14;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t1 = _context5["catch"](2);
          _iterator.e(_context5.t1);
        case 14:
          _context5.prev = 14;
          _iterator.f();
          return _context5.finish(14);
        case 17:
          // Attach dropdown event listeners after HTML is in the DOM
          setTimeout(function () {
            attachCustomDropdownListeners();
          }, 0);
          return _context5.abrupt("return", itemHTML);
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee4, null, [[2, 11, 14, 17]]);
  }));
}
function attachCustomDropdownListeners() {
  document.querySelectorAll(".custom-dropdown .selected-variant").forEach(function (selectedEl) {
    selectedEl.addEventListener("click", function () {
      var variantListEl = selectedEl.nextElementSibling;
      if (variantListEl instanceof HTMLElement) {
        if (variantListEl.style.display === "none") {
          variantListEl.style.display = "block";
        } else {
          variantListEl.style.display = "none";
        }
      }
    });
  });
  document.querySelectorAll(".custom-dropdown .variant-item").forEach(function (variantEl) {
    variantEl.addEventListener("click", function (e) {
      if (variantEl.dataset.available === "false") {
        var BISTrigger = variantEl.nextElementSibling;
        if (BISTrigger) {
          e.preventDefault();
          BISTrigger.click();
        }
      }
      var clickedVariantId = variantEl.getAttribute("data-variant-id");
      var innerHTML = variantEl.innerHTML;
      var variantTitle = variantEl.textContent.trim();
      var siblings = variantEl.parentElement.querySelectorAll(".variant-item");
      siblings.forEach(function (sib) {
        return sib.classList.remove("selected");
      });
      variantEl.classList.add("selected");
      var selectedVariantEl = variantEl.parentElement.previousElementSibling;
      selectedVariantEl.innerHTML = innerHTML;
      var wishlistItemEl = variantEl.closest(".wishlist-item");
      if (wishlistItemEl) {
        var buyButton = wishlistItemEl.querySelector(".wishlist_item_buy_button");
        if (buyButton) {
          buyButton.setAttribute("data-id", clickedVariantId);
        }
      }
      variantEl.parentElement.style.display = "none";
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  var wishlistModule = document.querySelector(".wishlist-module");
  if (wishlistModule) {
    wishlistModule.addEventListener("change", function (event) {
      var target = event.target;
      if (target.classList.contains("wishlist_variant_picker")) {
        var selectedVariantId = target.value;
        var selectedOption = target.options[target.selectedIndex];
        var wishlistItem = target.closest(".wishlist-item");
        var wishlistButton = wishlistItem.querySelector("wishlist-add_to_cart");
        var wishlistImage = wishlistItem.querySelector(".wishlist_item_image");
        var wishlistPrice = wishlistItem.querySelector(".wishlist_item_price");
        wishlistItem.dataset.id = selectedVariantId;
        wishlistButton.dataset.id = selectedVariantId;
        wishlistImage.src = selectedOption.getAttribute("data-image") || "";
        wishlistPrice.textContent = "".concat(Number(selectedOption.getAttribute("data-price")) / 100, " USD");
        var localWishlistItems = JSON.parse(localStorage.getItem("wishlist_items") || "[]");
        var updatedWishlistItems = localWishlistItems.map(function (item) {
          if (item.id == wishlistItem.dataset.id) {
            return Object.assign(Object.assign({}, item), {
              id: selectedVariantId,
              price: selectedOption.getAttribute("data-price"),
              compare_at_price: selectedOption.getAttribute("data-compare-at-price")
            });
          }
          return item;
        });
        localStorage.setItem("wishlist_items", JSON.stringify(updatedWishlistItems));
      }
    });
  }
});
function renderWishlistModule() {
  var localWishlistItems = localStorage.getItem("wishlist_items");
  var wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
  var wishlistModule = document.querySelector(".wishlist-module");
  var wishlistSection = document.querySelector(".wishlist-section");
  if (wishlistModule) {
    if (wishlistItems.length > 0) {
      wishlistSection.classList.add("active");
      wishlistModule.classList.remove("active");
    } else {
      wishlistModule.classList.add("active");
      wishlistSection.classList.remove("active");
    }
  }
  document.dispatchEvent(new Event("wishlist-changed"));
}
document.addEventListener("DOMContentLoaded", function () {
  renderWishlistModule();
});
var WishlistCount = /*#__PURE__*/function (_HTMLElement) {
  function WishlistCount() {
    _classCallCheck(this, WishlistCount);
    return _callSuper(this, WishlistCount);
  }
  _inherits(WishlistCount, _HTMLElement);
  return _createClass(WishlistCount, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      document.addEventListener("DOMContentLoaded", function () {
        _this.updateCount();
      });
      document.addEventListener("wishlist-changed", function () {
        _this.updateCount();
      });
    }
  }, {
    key: "updateCount",
    value: function updateCount() {
      var localWishlistItems = localStorage.getItem("wishlist_items");
      var wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
      this.innerHTML = wishlistItems.length.toString();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("wishlist-count", WishlistCount);
var WishlistButton = /*#__PURE__*/function (_HTMLElement2) {
  function WishlistButton() {
    var _this2;
    _classCallCheck(this, WishlistButton);
    _this2 = _callSuper(this, WishlistButton);
    _this2.id = _this2.dataset.id;
    if (_this2.id === "51068398174537") {
      console.log("constructor", _this2.id);
    }
    return _this2;
  }
  _inherits(WishlistButton, _HTMLElement2);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.updateButtonState();
      if (this.id === "51068398174537") {
        console.log("connectedCallback", this.id);
      }
      this.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        _this3.toggleWishlistItem(event);
      });
      var fieldSet = document.querySelector("fieldset");
      if (fieldSet) {
        fieldSet.addEventListener("change", function () {
          fetchProductAndUpdateButton();
        });
      }
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState() {
      var localWishlistItems = localStorage.getItem("wishlist_items");
      if (localWishlistItems) {
        var wishlistItems = JSON.parse(localWishlistItems);
        var attributesObject = Object.assign({}, this.dataset);
        var exists = wishlistItems.some(function (item) {
          return item.id == attributesObject.id;
        });
        if (exists) {
          this.classList.add("is-animating");
          if (attributesObject.cart === "true") {
            this.style.display = "none";
          }
        } else {
          this.classList.remove("is-animating");
          if (attributesObject.cart === "true") {
            this.style.display = "block";
          }
        }
      }
      document.dispatchEvent(new Event("wishlist-changed"));
    }
  }, {
    key: "toggleWishlistItem",
    value: function toggleWishlistItem(event) {
      var _this4 = this;
      this.classList.add("is-animating");
      var wishlistModuleBox = document.querySelector("#wishlist-module-box");
      var wishlistModuleImg = wishlistModuleBox.querySelector("#wishlist-module-img");
      var wishlistModuleTitle = wishlistModuleBox.querySelector("#wishlist-module-title");
      var wishlistModuleText = wishlistModuleBox.querySelector("#wishlist-module-text");
      var removeFromWishlistTextData = document.querySelector(".wishlist-button-text").getAttribute("data-removedText");
      var addToWishlistTextData = document.querySelector(".wishlist-button-text").getAttribute("data-addedText");
      wishlistModuleBox.classList.toggle("wishlist_module_alert");
      setTimeout(function () {
        wishlistModuleBox.classList.toggle("wishlist_module_alert");
      }, 1000);
      var localWishlistItems = localStorage.getItem("wishlist_items");
      var wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
      var attributesObject = Object.assign({}, this.dataset);
      wishlistModuleImg.setAttribute("src", attributesObject.images);
      wishlistModuleTitle.innerHTML = attributesObject.title;
      if (this.dataset.cart === "true") {
        var exists = wishlistItems.some(function (item) {
          return item.id == attributesObject.id;
        });
        if (!exists) {
          wishlistItems.push(attributesObject);
          localStorage.setItem("wishlist_items", JSON.stringify(wishlistItems));
          wishlistModuleText.innerHTML = removeFromWishlistTextData;
          setTimeout(function () {
            var cartRemoveButton = _this4.closest(".cart-item").querySelector(".cart-item__remove-button");
            if (cartRemoveButton) {
              cartRemoveButton.click();
            }
          }, 1000);
        } else {}
      } else {
        var _exists = wishlistItems.some(function (item) {
          return item.id == attributesObject.id;
        });
        if (!_exists) {
          wishlistItems.push(attributesObject);
          localStorage.setItem("wishlist_items", JSON.stringify(wishlistItems));
          wishlistModuleText.innerHTML = addToWishlistTextData;
          console.log("added to wishlist");
        } else {
          var newWishlistItems = wishlistItems.filter(function (item) {
            return item.id != attributesObject.id;
          });
          localStorage.setItem("wishlist_items", JSON.stringify(newWishlistItems));
          wishlistModuleText.innerHTML = removeFromWishlistTextData;
          console.log("removed from wishlist");
        }
        this.updateButtonState();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("wishlist-button", WishlistButton);
var WishlistElementsWrapper = /*#__PURE__*/function (_HTMLElement3) {
  function WishlistElementsWrapper() {
    var _this5;
    _classCallCheck(this, WishlistElementsWrapper);
    _this5 = _callSuper(this, WishlistElementsWrapper);
    _this5.url = _this5.dataset.url;
    _this5.getWishlistHtml = function (wishlistItems) {
      return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this6 = this;
        var wishlistProductIds, batchSize, batches, i, responses, template, allHtml;
        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              console.log("wishlistItems", wishlistItems);
              _context7.next = 4;
              return Promise.all(wishlistItems.map(function (item) {
                return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                  var id;
                  return _regeneratorRuntime().wrap(function _callee5$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        id = item.productid;
                        if (id) {
                          _context6.next = 3;
                          break;
                        }
                        return _context6.abrupt("return", "");
                      case 3:
                        return _context6.abrupt("return", "id:".concat(id));
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee5);
                }));
              }));
            case 4:
              wishlistProductIds = _context7.sent;
              console.log("wishlistProductIds", wishlistProductIds);
              batchSize = 20;
              batches = [];
              for (i = 0; i < wishlistProductIds.length; i += batchSize) {
                batches.push(wishlistProductIds.slice(i, i + batchSize).join(" OR "));
              }
              _context7.next = 11;
              return Promise.all(batches.map(function (batchQuery) {
                return fetch("".concat(_this6.url, "&q=").concat(batchQuery)).then(function (res) {
                  if (!res.ok) throw new Error("Network response was not ok");
                  return res.text();
                });
              }));
            case 11:
              responses = _context7.sent;
              template = document.createElement("template");
              allHtml = responses.map(function (html) {
                template.innerHTML = html;
                console.log("template", template);
                var wishlistWrapper = template.content.querySelector("wishlist-elements-wrapper");
                return wishlistWrapper ? Array.from(wishlistWrapper.children).map(function (child) {
                  return child.outerHTML;
                }).join("") : "";
              }).join("");
              return _context7.abrupt("return", allHtml);
            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7["catch"](0);
              console.log(_context7.t0);
              return _context7.abrupt("return", "");
            case 21:
            case "end":
              return _context7.stop();
          }
        }, _callee6, null, [[0, 17]]);
      }));
    };
    return _this5;
  }
  _inherits(WishlistElementsWrapper, _HTMLElement3);
  return _createClass(WishlistElementsWrapper, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.init();
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var localWishlistItems, wishlistItems;
        return _regeneratorRuntime().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              localWishlistItems = localStorage.getItem("wishlist_items");
              wishlistItems = JSON.parse(localWishlistItems);
              this.innerHTML = "";
              _context9.t0 = "\n        <div class=\"item-container\">\n          <div class=\"custom-grid-container\">\n          ";
              _context9.next = 6;
              return this.getWishlistHtml(wishlistItems);
            case 6:
              _context9.t1 = _context9.sent;
              this.innerHTML = _context9.t0.concat.call(_context9.t0, _context9.t1, "\n          </div>\n        </div>\n      ");
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("wishlist-elements-wrapper", WishlistElementsWrapper);
var RemoveItem = /*#__PURE__*/function (_HTMLElement4) {
  function RemoveItem() {
    _classCallCheck(this, RemoveItem);
    return _callSuper(this, RemoveItem);
  }
  _inherits(RemoveItem, _HTMLElement4);
  return _createClass(RemoveItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this7 = this;
      this.addEventListener("click", function (event) {
        return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
          var localWishlistItems, wishlistItems, id, newWishlistItems, wishlistElementsWrapper;
          return _regeneratorRuntime().wrap(function _callee9$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                event.preventDefault();
                localWishlistItems = localStorage.getItem("wishlist_items");
                wishlistItems = JSON.parse(localWishlistItems);
                id = this.id;
                console.log("id", id);
                newWishlistItems = wishlistItems.filter(function (item) {
                  return item.productid != id;
                });
                localStorage.setItem("wishlist_items", JSON.stringify(newWishlistItems));
                document.dispatchEvent(new Event("wishlist-changed"));
                wishlistElementsWrapper = document.querySelector("wishlist-elements-wrapper");
                wishlistElementsWrapper.innerHTML = "";
                wishlistElementsWrapper.init();
                window.location.reload();
              case 12:
              case "end":
                return _context10.stop();
            }
          }, _callee9, this);
        }));
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("remove-item", RemoveItem);
var WishlistAddToCart = /*#__PURE__*/function (_HTMLElement5) {
  function WishlistAddToCart() {
    _classCallCheck(this, WishlistAddToCart);
    return _callSuper(this, WishlistAddToCart);
  }
  _inherits(WishlistAddToCart, _HTMLElement5);
  return _createClass(WishlistAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this8 = this;
      var addToCartButton = this.querySelector("button");
      addToCartButton.addEventListener("click", function (event) {
        return __awaiter(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
          var _a, wishlistItem, buyButton, selectedVariantId, formData, localWishlistItems, updatedWishlistItems, wishlistElementsWrapper;
          return _regeneratorRuntime().wrap(function _callee10$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                event.preventDefault();
                wishlistItem = this.closest(".wishlist-item");
                buyButton = wishlistItem.querySelector(".wishlist_item_buy_button"); // Read the variant ID from the 'data-id' attribute
                selectedVariantId = parseInt((_a = buyButton === null || buyButton === void 0 ? void 0 : buyButton.dataset.id) !== null && _a !== void 0 ? _a : "", 10);
                if (!isNaN(selectedVariantId)) {
                  _context11.next = 7;
                  break;
                }
                console.error("Invalid variant ID selected!");
                return _context11.abrupt("return");
              case 7:
                formData = {
                  items: [{
                    id: selectedVariantId,
                    quantity: 1
                  }]
                };
                _context11.next = 10;
                return AddToCart(formData);
              case 10:
                localWishlistItems = JSON.parse(localStorage.getItem("wishlist_items") || "[]");
                updatedWishlistItems = localWishlistItems.filter(function (item) {
                  return item.id !== selectedVariantId;
                });
                localStorage.setItem("wishlist_items", JSON.stringify(updatedWishlistItems));
                wishlistElementsWrapper = document.querySelector("wishlist-elements-wrapper");
                _context11.t0 = "\n        <div class=\"item-container\">\n          <div class=\"custom-grid-container\">\n            ";
                _context11.next = 17;
                return renderWishList(updatedWishlistItems);
              case 17:
                _context11.t1 = _context11.sent;
                wishlistElementsWrapper.innerHTML = _context11.t0.concat.call(_context11.t0, _context11.t1, "\n          </div>\n        </div>\n      ");
                renderWishlistModule();
                document.dispatchEvent(new CustomEvent("theme:cartchanged", {
                  bubbles: true,
                  cancelable: false
                }));
                document.dispatchEvent(new CustomEvent("theme:open-cart-drawer", {
                  bubbles: true,
                  cancelable: false
                }));
              case 22:
              case "end":
                return _context11.stop();
            }
          }, _callee10, this);
        }));
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
function getProductData(url, variantId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var response, data, variants, selectedVariant, status;
    return _regeneratorRuntime().wrap(function _callee11$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return fetch("".concat(url, ".js"));
        case 3:
          response = _context12.sent;
          if (!response.ok) {
            _context12.next = 14;
            break;
          }
          _context12.next = 7;
          return response.json();
        case 7:
          data = _context12.sent;
          variants = data.variants;
          selectedVariant = variants.filter(function (variant) {
            return variant.id == variantId;
          });
          status = selectedVariant[0].available;
          return _context12.abrupt("return", status);
        case 14:
          console.log(response);
        case 15:
          _context12.next = 20;
          break;
        case 17:
          _context12.prev = 17;
          _context12.t0 = _context12["catch"](0);
          console.log(_context12.t0);
        case 20:
          _context12.prev = 20;
          return _context12.finish(20);
        case 22:
        case "end":
          return _context12.stop();
      }
    }, _callee11, null, [[0, 17, 20, 22]]);
  }));
}

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {



/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkFashionByStrand"] = self["webpackChunkFashionByStrand"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/reload-cart.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/TermsAndConditions.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/wishlist.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;